import * as React from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@dropbox/dig-components/tooltips';
import { SlidesLine, SignOutLine } from '@dropbox/dig-icons/assets';
import { useIsNestedArchiveFile, useSharedLinkInfo } from 'js/file_viewer/api/data';
import { useHideToolsCallback, useToggleSlideshowCallback } from 'js/file_viewer/api/navigation';
import { useAreToolsHidden, useIsFullscreen, useIsSlideshow } from 'js/file_viewer/api/ui';
import { useFileViewerContext } from 'js/file_viewer/contexts/file_viewer';
import { UserActionContext } from 'js/file_viewer/core/logging/constants';
import { useStabilizedCallback } from 'js/file_viewer/core/utils/useStabilizedCallback';
import { ToolbarIcon } from 'js/file_viewer/toolbar/utils';
import { shouldShowSlideshowButton } from 'js/file_viewer/utils/slideshow';
export const SlideShowButton = ({ variant, previewType }) => {
    const intl = useIntl();
    const isFullScreen = useIsFullscreen();
    const isSlideshow = useIsSlideshow();
    const areToolsHidden = useAreToolsHidden();
    const isSharedFile = !!useSharedLinkInfo();
    const isNestedArchive = useIsNestedArchiveFile();
    const { featureConfig } = useFileViewerContext();
    const toggleSlideshowCallback = useToggleSlideshowCallback();
    const hideToolsCallback = useHideToolsCallback(UserActionContext.PreviewToolbar);
    const isSlideshowStormcrowEnabled = featureConfig.preview_collection_slideshow === 'ON';
    const onSlideshow = useStabilizedCallback(() => {
        toggleSlideshowCallback({ actionContext: UserActionContext.PreviewToolbar });
        if (!areToolsHidden && !isSlideshow) {
            hideToolsCallback();
        }
    });
    const slideshowLabel = isSlideshow
        ? intl.formatMessage({ id: "EIxINn", defaultMessage: "Exit slideshow" })
        : intl.formatMessage({ id: "APqiEA", defaultMessage: "Slideshow" });
    const tooltipLabel = isSlideshow
        ? intl.formatMessage({ id: "3xoy9+", defaultMessage: "Exit slideshow" })
        : intl.formatMessage({ id: "86x3d6", defaultMessage: "Slideshow" });
    return shouldShowSlideshowButton(previewType, isSlideshowStormcrowEnabled, featureConfig.file_flipping, isNestedArchive, isSharedFile) ? (React.createElement(Tooltip, { title: tooltipLabel, placement: "bottom" },
        React.createElement("span", { "data-tooltip": tooltipLabel },
            React.createElement(ToolbarIcon, { label: slideshowLabel, onClick: onSlideshow, icon: isFullScreen && isSlideshow ? SignOutLine : SlidesLine, disabled: false, variant: variant })))) : null;
};
SlideShowButton.displayName = "SlideShowButton"
//# sourceMappingURL=slideshow_button.preenvesnextjs.map
